module.exports = __webpack_public_path__ + "officialStatic/img/schoolBg2.3fbd967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/schoolBg2.jpg
// module id = RwB8
// module chunks = 0